import axios from "axios"

export const formatDateTime = (dateString) => {
  if (!dateString) return ""

  const date = new Date(dateString)

  return date.toLocaleString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    // timeZoneName: "short",
    // timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  })
}

export const fetchMaintenanceWindow = async () => {
  try {
    const response = await axios.get(`/notification/`) // replace with network response from qa for local testing
    // const response = {
    //   "success": true,
    //   "data": {
    //     "notification": {
    //       "title": "Rishabh Test",
    //       "start_time": "2025-05-05T18:38:00Z",
    //       "end_time": "2025-05-05T18:39:00Z",
    //       "warning_lead": 2
    //     }
    //   }
    // }; // use this for manual testing for maintenance banner and page
    return response.data.notification
  } catch (error) {
    console.error("Error fetching maintenance window:", error)
    return null
  }
}

export const isInMaintenanceWindow = (maintenanceData) => {
  if (!maintenanceData || !maintenanceData.start_time || !maintenanceData.end_time) {
    return false
  }

  const now = new Date()
  const startTime = new Date(maintenanceData.start_time)
  const endTime = new Date(maintenanceData.end_time)

  return now >= startTime && now <= endTime
  // return true
}

export const shouldShowWarning = (maintenanceData) => {
  if (!maintenanceData || !maintenanceData.start_time || !maintenanceData.warning_lead) {
    return false
  }

  const now = new Date()
  const startTime = new Date(maintenanceData.start_time)

  const warningStartTime = new Date(startTime)
  warningStartTime.setHours(warningStartTime.getHours() - maintenanceData.warning_lead)

  return now >= warningStartTime && now < startTime
  // return true
}
